/**
 * @module
 * @author Bayu Dwiyan Satria
 * @since 1.0.0
 */

/**
 * Services
 */
import { healthService } from '@/services/healthService'

/**
 * The API surface, as one object.
 *
 * @remarks
 * A single entry point gives views one import to remember and one place to see everything the
 * application talks to. It also makes the whole API trivially replaceable in a test: provide an
 * object with the same shape and no component needs to know.
 *
 * @example
 * ```ts
 * import { api } from '@/services/client'
 *
 * const health = await api.health.getStatus()
 * ```
 */
export const api = {
  health: healthService
}
